export default __webpack_public_path__ + "static/media/banner_3.5fd1555e.jpg";